import { render, staticRenderFns } from "./CampaignTypeSelector.vue?vue&type=template&id=56832d7a&scoped=true&"
import script from "./CampaignTypeSelector.vue?vue&type=script&lang=js&"
export * from "./CampaignTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./CampaignTypeSelector.vue?vue&type=style&index=0&id=56832d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56832d7a",
  null
  
)

export default component.exports